<template>
  <div class="container">
    <div class="top">
      <p class="name">
        <span>企业总充值 :</span>
        <span style='color:#ff3300'>&nbsp;&nbsp;￥{{sum?sum:0.00}}</span>
      </p>
      <div class="search-wrap">
        <!-- <el-input
          class="search"
          placeholder="搜索部门名称"
          v-model="searchStr"
          @input ="inputChange(searchStr)"
          >
        <i slot="suffix"
          class="el-input__icon el-icon-search"
          @click="querySearch(searchStr)"
        ></i>
        </el-input> -->
        <el-button type="primary" @click="addCouster">申请企业充值</el-button>
      </div>
    </div>
    <!-- <div class="tipes" >说明：客户列表中的成员可免费在润泽食堂用餐。</div> -->
    <div class='table'>
      <div class='title'>申请企业充值记录:</div>
      <el-table :data="mates"
                align='center'
                style="width: 100%">
        <el-table-column prop="amount"
                        align='center'
                        label="充值金额"
                        >
        </el-table-column>
        <el-table-column prop="operator"
                        align='center'
                        label="申请人"
                        >
        </el-table-column>
        <el-table-column prop="createTime"
                        align='center'
                        label="提交时间"
                        width="200"
                        >
                        <template slot-scope="scope">
                          {{scope.row.createTime.replace(/\-/g, "/")}}
                        </template>
        </el-table-column>
        <el-table-column prop="status"
                        align='center'
                        label="状态"
                        >
          <template slot-scope="scope">
            <span>{{statusChange(scope.row.status)}}</span>
          </template>
        </el-table-column>
        <el-table-column
                        align='center'
                        label="操作"
                        >
          <template slot-scope="scope">
            <!-- 直接在click事件上把当前要操作的用户的信息赋值了，省去了在写一个方法，不过这种写法合适不合适需要讨论 -->
            <el-button @click.native.prevent="toViewDetail(scope.row.orderId)"
                      type="text">
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="prev, pager, next"
        :page-size="5"
        align='center'
        @current-change="pageChange"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      title="申请企业充值"
      :visible.sync="addVisible"
      :before-close="close"
      align='center'
      width="30%">
      <div class='addTopUp'>
        <div class='name'>
          <span class='nameText'>企业名称 :</span>
          <span class='nameValue'>{{companyName}}</span>
        </div>
        <div class='name'>
          <span class='nameText'>充值金额 :</span>
          <span class='nameValue'>
            <el-input v-model="employeeName" :maxlength="10" oninput ="value=value.replace(/[^0-9.]/g,'')" placeholder="请输入充值金额"></el-input>
          </span>
        </div>
        <div class='name'>
          <span class='nameText'>充值备注 :</span>
          <span class='nameValue'>
            <el-input class='textarea' v-model="textarea" placeholder="请输入充值备注（选填 ）"></el-input>
          </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="next">下一步</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="确认申请企业充值"
      :visible.sync="sureVisible"
      :before-close="close"
      align='center'
      width="30%">
      <div class='sureTopUp'>
        <div class='name'>
          <span class='nameText'>企业名称 :</span>
          <span class='nameValue'>{{companyName}}</span>
        </div>
        <div class='name'>
          <span class='nameText'>充值金额 :</span>
          <span class='nameValue'>￥{{employeeName|number}}</span>
        </div>
        <div class='text'>
          <span class='nameText'>充值备注 :</span>
          <span class='nameValue'>{{textarea?textarea:'无'}}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="prev">上一步</el-button>
        <el-button type="primary" @click="submit">提交申请</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="企业充值详情"
      :visible.sync="editVisible"
      @close='closeDialog'
      align='center'
      width="30%">
      <div class='content'>
        <div class='name'>
          <span class='nameText'>充值公司 :</span>
          <span class='nameValue'>{{companyName}}</span>
        </div>
        <div class='name'>
          <span class='nameText'>充值金额 :</span>
          <span class='nameValue'>￥{{refundRecordData.amount|number}}</span>
        </div>
        <div class='text'>
          <span class='nameText'>充值备注 :</span>
          <span class='nameValue'>{{refundRecordData.desc}}</span>
        </div>
        <div class='name'>
          <span class='nameText'>申请时间 :</span>
          <span class='nameValue'>{{refundRecordData.createTime}}</span>
        </div>
        <div class='name'>
          <span class='nameText'>申请人 :</span>
          <span class='nameValue'>{{refundRecordData.operator}}</span>
        </div>
        <div class='name'>
          <span class='nameText'>状态 :</span>
          <span class='nameValue'>{{statusChange(refundRecordData.status)}}</span>
        </div>
        <div v-show='refundRecordData.status != 0'>
          <div class='name'>
            <span class='nameText'>审核人 :</span>
            <span class='nameValue'>{{refundRecordData.updateUser}}</span>
          </div>
          <div class='text' v-show='refundRecordData.status == 3'>
            <span class='nameText'>审核备注 :</span>
            <span class='nameValue'>{{refundRecordData.updateDesc}}</span>
          </div>
          <div class='name'>
            <span class='nameText'>审核时间 :</span>
            <span class='nameValue'>{{refundRecordData.updateTime}}</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script >
import { getTopUpData, submitTopUp, searchTopUp } from '@/api/topUp'
import bus from '@/utils/bus'
export default {
  data () {
    return {
      addVisible: false,
      editVisible: false,
      mates: [],
      companyId: '',
      companyName: '',
      searchStr: '',
      currentId: '', // 当前要操作的用户
      employeeName: '',
      deductionInput: '',
      tipShow: false,
      succ: false,
      page: 1,
      pageSize: 6,
      addInput: false,
      addText: '',
      status: true,
      total: '',
      sum: '',
      sureVisible: false,
      refundRecordData: {},
      textarea: '',
      isDisable: false
    }
  },
  props: [],
  components: {
  },
  mounted () {
    this.companyId = localStorage.companyId
    this.companyName = JSON.parse(localStorage.company).name
    console.log(this.companyName)
    bus.$on('changeCompany', id => {
      this.companyId = id
      this.companyName = JSON.parse(localStorage.company).name
      this.getMates(1)
    })
    this.getMates(1)
  },
  computed: {
    newSearchStr () {
      // this.querySearch(searchStr);
      this.searchStr + ''
      console.log(this.searchStr)
    }
  },
  methods: {
    // 新增充值
    addCouster () {
      this.addVisible = true
    },
    handleClose () {
      this.dialogVisible = false
    },
    // 获取充值列表
    getMates (pages) {
      let data = {
        companyId: this.companyId,
        page: pages,
        size: this.pageSize
      }
      getTopUpData(data).then(res => {
        console.log(res)
        this.mates = res.data
        this.sum = res.sum
        this.total = res.count
      })
    },
    // 确认修改充值信息
    editUser () {
      if (!this.oldTagValue) {
        this.$message('请输入姓名')
        return
      }
      let data = {
        id: this.currentId,
        name: this.oldTagValue
      }
      console.log(data)
      editDepartment(data).then(res => {
        console.log(res)
        if (res.msg === 'success') {
          this.$message({
            type: 'success',
            message: '编辑成功'
          })
          this.editVisible = false
          this.getMates(this.page)
        } else {
          this.$message({
            type: 'warn',
            message: res.msg
          })
        }
      })
    },
    timeFomatter (row, col) {
      return new Date(row[col.property]).toLocaleString()
    },
    moenyFomat (row, col) {
      return parseFloat(row[col.property]).toFixed(2)
    },
    statusFormatter (row, col) {
      let str = row[col.property]
      switch (str) {
        case 0:
          str = '未激活'
          break
        case 1:
          str = '正常'
          break
      }
      return str
    },
    // 搜索充值
    querySearch (queryString) {
      let data = {
        companyId: localStorage.companyId,
        page: 1,
        size: 10,
        keyword: queryString
      }
      console.log(data)
      serMatesByDepartment(data).then(res => {
        this.mates = res.data.list
        this.userNumber = res.data.count
      })
    },
    inputChange (val) {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      if (val) {
        this.timer = setTimeout(() => {
          this.querySearch(val)
        }, 500)
      } else {
        this.querySearch(val)
      }
    },
    // 关闭弹窗
    handleDialogClose () {
      this.delVisibles = false
      this.succ = false
      setTimeout(() => {
        this.deductionInput = ''
      }, 500)
    },
    next () {
      if (!this.employeeName) {
        this.$message('请输入充值金额')
        return
      }
      if (this.employeeName <= 0) {
        this.$message('充值金额必须大于0')
        return
      }

      this.addVisible = false
      setTimeout(() => {
        this.sureVisible = true
      }, 500)
    },
    prev () {
      this.sureVisible = false
      setTimeout(() => {
        this.addVisible = true
      }, 500)
    },
    pageChange (page) {
      this.page = page
      this.getMates(page)
    },
    toViewDetail (id) {
      let data = {
        orderId: id
      }
      searchTopUp(data).then(res => {
        console.log(res)
        this.refundRecordData = res
        this.editVisible = true
      }).catch(error => {
        console.log(error)
      })
    },
    // 充值状态变换
    statusChange (val) {
      switch (val) {
        case 0: return '审核中'; break
        case 2: return '审核成功'; break
        case 3: return '审核失败'; break
        default: return '状态错误'
      }
    },
    submit () {
      if (this.isDisable) {
        return false
      }
      if (!this.employeeName) {
        this.$message('金额不能为0')
        return
      }
      this.isDisable = true
      // setTimeout(() => {
      //   this.isDisable = false
      // }, 1000);
      let data = {
        companyId: this.companyId,
        money: this.employeeName,
        desc: this.textarea
      }
      submitTopUp(data).then(res => {
        console.log(res)
        this.$message('申请企业充值成功')
        this.sureVisible = false
        this.getMates(this.page)
        this.employeeName = ''
        this.textarea = ''
        this.isDisable = false
      }).catch(err => {
        this.$message('提交失败')
        this.sureVisible = false
        this.employeeName = ''
        this.textarea = ''
        this.isDisable = false
      })
    },
    close () {
      this.sureVisible = false
      this.addVisible = false
      this.employeeName = ''
      this.textarea = ''
    }
  },
  filters: {
    number: function (val) {
      val = String(val).replace(/\$|\,/g, '')
      if (isNaN(val)) {
        val = '0'
      }
      let sign = (val == (val = Math.abs(val)))
      val = Math.floor(val * 100 + 0.50000000001)
      let cents = val % 100
      val = Math.floor(val / 100).toString()
      if (cents < 10) {
        cents = '0' + cents
      }
      for (var i = 0; i < Math.floor((val.length - (1 + i)) / 3); i++) {
        val = val.substring(0, val.length - (4 * i + 3)) + ',' + val.substring(val.length - (4 * i + 3))
      }
      return (((sign) ? '' : '-') + val + '.' + cents)
    }
  }
}
</script>

<style scoped lang="scss">
%row{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.container{
  .top{
    @extend %row;
    justify-content: space-between;
    border-bottom:1px solid #eee;
    padding-bottom: 20px;
    .name{
      font-size: 28px;
      flex-basis: 68%;
    }
    .search-wrap{
      flex:1;
      display: flex;
      justify-content: flex-end;
    }
    .search{
      width: 60%;
      margin-right:8%;
    }
  }
  .tipes{
    font-size: 14px;
    color:#AAAAAA;
    margin-bottom: 10px;
  }
  .table{
    .title{
      display: flex;
      width: 100%;
      height: 48px;
      font-size: 16px;
      line-height: 48px;
    }
  }
}
.tip{
  color:#409EFF;
  cursor:pointer;
}
.error{
  color: lightcoral;
}
.box{
  display: flex;
  justify-content: space-between;
  .font{
    font-size: 14px;
    line-height: 20px;
  }
}
.dialog-footer{
  display: flex;
  justify-content: space-around;
  .el-button--primary{
    width:50%;
    color:rgba(2, 167, 240, 1);
    background:#fff;
    border:1px solid rgba(2, 167, 240, 1);
  }
}
.del-footer{
  display: flex;
  justify-content: space-around;
  .el-button--primary{
    color:#D9001B;
    background:#fff;
    border:1px solid rgba(217, 0, 27, 1);
  }
}
.confirm{
  text-align: center;
  .box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .font{
      flex-basis:20%;
      font-size: 14px;
      line-height: 20px;
      text-align: left;
    }
    .input{
      flex-basis:65%;
      flex: 1;
    }
    .unit{
      flex-basis:5%;
      text-align: right;
    }
  }
  .prompt{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top:20px;
    .text{
      font-size: 14px;
      line-height: 20px;
    }
    .assignment{
      cursor:pointer;
    }
  }
  .tips{
    font-size: 12px;
    line-height: 18px;
    color:#FF5000;
    text-align: left;
    margin-top: 11px;
  }
  .remark{
    font-size: 12px;
    line-height: 18px;
    color:#999999;
    text-align: left;
    margin-top: 20px;
  }
  .hidden{
    display: none;
  }
}
.succ{
  .boxs{
    display: flex;
    justify-content: flex-start;
    .font{
      .color{
        color:#409EFF;
      }
    }
  }
}
::v-deep .el-select {
    display: block;
    position: relative;
}
.select{
  ::v-deep  .el-input--small .el-input__inner{
    width:100%;
    height: 40px;
    line-height: 40px;
  }
}
.addTagText{
  font-size: 14px;
  padding: 0 20px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  .name{
    display: block;
    font-size: 16px;
    line-height: 40px;
    color: #027DB4;
    cursor: pointer;
  }
  .input{
    height:40px;
    ::v-deep  .el-input__inner{
      height: 34px;
      line-height: 34px;
    }

  }
}
.delIcon{
  width:20px;
  height:20px;
  position: absolute;
  top:30%;
  right:2%;
  z-index: 10;
  display: none;
}
::v-deep  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover .delIcon{
  display: block;
}
::v-deep .el-dialog__body {
  padding: 10px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.content{
  width:100%;
  height:100%;
  .name{
    display: flex;
    height:40px;
    font-size: 15px;
    line-height: 40px;
    color: #666666;
    text-align: left;
    .nameText{
      flex-basis: 25%;
    }
    .nameValue{
      flex:1;

    }
  }
  .text{
    display: flex;
    height:auto;
    font-size: 15px;
    line-height: 40px;
    color: #666666;
    text-align: left;
    position: relative;
    .nameText{
      flex-basis: 25%;
      position: absolute;
      top:0;
      padding-left:0;
    }
    .nameValue{
      flex:1;
      margin-left:25%;
    }
  }
}
.addTopUp{
  width:100%;
  height:100%;
  padding-bottom: 10px;
  .name{
    display: flex;
    height:40px;
    font-size: 15px;
    line-height: 40px;
    color: #666666;
    text-align: left;
    margin-bottom:20px;
    .nameText{
      flex-basis: 25%;
    }
    .nameValue{
      flex:1;
      .textarea{
        width:100%;
        height:60px;
      }
    }
  }
  .text{
    display: flex;
    height:auto;
    font-size: 15px;
    line-height: 40px;
    color: #666666;
    text-align: left;
    position: relative;
    .nameText{
      flex-basis: 25%;
      position: absolute;
      top:0;
      padding-left:0;
    }
    .nameValue{
      flex:1;
      margin-left:25%;
    }
  }
}
.sureTopUp{
  width:100%;
  height:100%;
  .name{
    display: flex;
    height:40px;
    font-size: 15px;
    line-height: 40px;
    color: #666666;
    text-align: left;
    margin-bottom:20px;
    .nameText{
      flex-basis: 25%;
    }
    .nameValue{
      flex:1;
      .textarea{
        width:100%;
        height:60px;
      }
    }
  }
  .text{
    display: flex;
    height:auto;
    font-size: 15px;
    line-height: 40px;
    color: #666666;
    text-align: left;
    position: relative;
    .nameText{
      flex-basis: 25%;
      position: absolute;
      top:0;
      padding-left:0;
    }
    .nameValue{
      flex:1;
      margin-left:25%;
      line-height: 40px;
    }
  }
}
</style>
